import React from "react";
import { Text, Box, Image } from "@quintoandar-tokko/jopijs";
import style from "./poweredByTokko.module.scss";
import tokkoLogo from "@/public/logotokkobroker_horiz_gris.svg";
import { handleLinkClick } from "../utilities/helpers";
import { useSelector } from "react-redux";
import Skeletons from "../skelenton/Skeleton";

const PoweredByTokko = () => {
  const { loading, from_opennavent, portal_icon } = useSelector(
    (state) => state.FichaInfoSlice
  );
  if (loading) return <Skeletons width={170} height={30} />;
  return (
    <Box className={style.powered_container}>
      <Text color="var(--colors-neutral-grey-800)" variant="bodyBold.fontSize12">
        Powered by
      </Text>
      <Image
        onClick={() => handleLinkClick("https://www.tokkobroker.com")}
        className={style.imgContainer}
        src={tokkoLogo.src}
      />
      {from_opennavent && (
        <Image
          marginLeft="4px"
          filter="grayscale(10%)"
          className={style.opennaventImg}
          src={portal_icon}
        />
      )}
    </Box>
  );
};

export default PoweredByTokko;
